// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__cCBBa","left":"StickyBox_left__t7UqC","right":"StickyBox_right__2eoq9"};